export default "__VITE_ASSET__BIuEZUOc__"